import { useIsAggregatedAirline } from "../../../hooks/useIsAggregatedAirline";
import { useSelectedAirline } from "../../../hooks/useSelectedAirline";
import { MultiSeriesSearchCoverageLoader } from "./MultiSeriesSearchCoverageLoader";
import { SingleSeriesSearchCoverageLoader } from "./SingleSeriesSearchCoverageLoader";

export type SearchCoverageChartLoaderProps = {
  from: Date;
  to: Date;
};

export const SearchCoverageChartLoader = ({ from, to }: SearchCoverageChartLoaderProps) => {
  const isAggregatedAirline = useIsAggregatedAirline();
  const { selectedAirlineCodes } = useSelectedAirline({ useSuspense: true });

  if (isAggregatedAirline && selectedAirlineCodes.length > 1) {
    return <MultiSeriesSearchCoverageLoader from={from} to={to} />;
  }

  return <SingleSeriesSearchCoverageLoader from={from} to={to} />;
};
